import React from 'react'
import {Graph} from './Graph';
import {Transactions} from './Transactions';
import {AddTransaction} from './AddTransaction';
import {useState, useEffect} from 'react';

export const TransactionSection = () => {
    const onDelete = (transaction)=>{
        setTransactions(transactions.filter((e)=>{
        return e!==transaction;
        }))
        localStorage.setItem("$TRANSACTIONS", JSON.stringify(transactions));
    }

    const add_transaction = (sender, receiver, amount, ttype, desc, time, date)=> {
        let sno;
        if (transactions.length===0){
            sno = 1;
        }
        else{
            sno = transactions[transactions.length-1].tid + 1;
        }
        const myTransaction = {
            tid: sno,
            sender: sender,
            receiver : receiver,
            amount: amount,
            ttype: ttype,
            date: date,
            time: time,
            desc: desc
        }
        setTransactions([...transactions, myTransaction]);  
    }

    const [transactions, setTransactions] = useState(JSON.parse(localStorage.getItem("$TRANSACTIONS")));
    useEffect(() => {
        localStorage.setItem("$TRANSACTIONS", JSON.stringify(transactions));
    }, [transactions])
  return (
    <div>
        <div>
            <AddTransaction add_transaction={add_transaction} />
        </div>
        <div style={{backgroundColor: "rgb(16, 18, 57)", paddingTop: "100px",  paddingBottom: "100px"}}>
            <Transactions transactions={transactions} onDelete={onDelete} />
        </div>
        <div>
            <Graph/>
        </div>
    </div>
  )
}
